import React, { useState, useEffect } from 'react';
import { 
  // Lock, 
  // Bell, 
  // Calendar, 
  // Trophy, 
  Target, 
  // User, 
  // AlertTriangle, 
  LogOut 
} from 'lucide-react';
import '../../styles/Settings.css';
import Mina from '../../assets/images/mina.png';
import PricingModal from '../../components/modals/PricingModal';
import { API_URL } from '../../app/constants'

const SettingsView = () => {
  const [user, setUser] = useState(null);
  // const [notifications, setNotifications] = useState(true); // Commented out - not used
  // const [ setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    target_level: ''
  });
  const [jlptData, setJlptData] = useState({
    targetLevel: 'N5',
    examSession: 'july'
  });
  const [clickCount, setClickCount] = useState(0);
  
  // Level change modal states
  const [showLevelChangeModal, setShowLevelChangeModal] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [isChangingLevel, setIsChangingLevel] = useState(false);
  const [resetPreview, setResetPreview] = useState(null);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [showUnsubscribeConfirmation, setShowUnsubscribeConfirmation] = useState(false);

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      const jwt = localStorage.getItem('jwt');
      
      try {
        const response = await fetch(`${API_URL}/api/v1/auth/me`, {
          headers: { 'Authorization': `Bearer ${jwt}` },
          method: 'GET'
        });
        
        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
          
          // Get first and last name from direct fields or split from name
          let firstName = userData.first_name || '';
          let lastName = userData.last_name || '';
          
          // If no direct first/last name fields, try splitting the name field
          if (!firstName && !lastName && userData.name) {
            const nameParts = userData.name.split(' ');
            firstName = nameParts[0] || '';
            lastName = nameParts.slice(1).join(' ') || '';
          }
          
          // The backend returns the level as 'level', not 'target_level'
          const userLevel = userData.level || userData.target_level || 'N5';
          console.log('User level from API:', userLevel);
          
          setProfileData({
            firstName: firstName,
            lastName: lastName,
            email: userData.email || '',
            target_level: userLevel
          });
          
          setJlptData({
            targetLevel: userLevel,
            examSession: 'july' // Default to July as this is not in current API
          });
          
          // setNotifications(userData.notification_settings?.email !== false); // Commented out
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        // Loading removed
      }
    };
    
    fetchUserData();
  }, []); // Removed setNotifications dependency

  // const handleProfileChange = (e) => {
  //   const { name, value } = e.target;
  //   setProfileData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  // const handleJlptChange = (e) => {
  //   const { name, value } = e.target;
    
  //   // Prevent changes to targetLevel - as it's now locked
  //   if (name === 'targetLevel') {
  //     console.log('Target level change prevented - field is locked');
  //     return;
  //   }
    
  //   setJlptData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
    
  //   // Only handle changes for examSession now
  //   if (name === 'examSession') {
  //     // No need to update backend for exam session changes currently
  //     // If needed in the future, add the API call here
  //   }
  // };

  // const toggleNotifications = () => {
  //   const newValue = !notifications;
  //   setNotifications(newValue);
    
  //   // Update only notifications settings on server, not the target level
  //   saveProfileChanges({
  //     name: `${profileData.firstName} ${profileData.lastName}`,
  //     notification_settings: {
  //       email: newValue,
  //       app: newValue
  //     }
  //   });
  // };

  // const saveProfile = () => {
  //   // Build full name from first and last name
  //   const fullName = `${profileData.firstName} ${profileData.lastName}`.trim();
    
  //   // Save to backend - don't include target_level as it can't be changed
  //   saveProfileChanges({
  //     name: fullName,
  //     notification_settings: {
  //       email: notifications,
  //       app: notifications
  //     }
  //   });
    
  //   setIsEditing(false);
  // };

  // const saveProfileChanges = async (data) => {
  //   const jwt = localStorage.getItem('jwt');
    
  //   try {
  //     console.log('Updating profile with data:', data);
      
  //     // Make sure we have the required fields
  //     const updatedData = {
  //       ...data
  //     };
      
  //     // Ensure name exists
  //     if (!updatedData.name || updatedData.name.trim() === '') {
  //       updatedData.name = profileData.email || 'User';
  //     }
      
  //     // Try to update profile with better error handling
  //     try {
  //       // Use the correct backend endpoint for changing level
  //       const response = await fetch(`${API_URL}/api/v1/auth/change-level`, {
  //         method: 'POST',
  //         headers: {
  //           'Authorization': `Bearer ${jwt}`,
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({ level: updatedData.target_level })
  //       });
        
  //       if (response.ok) {
  //         // Update user state with new data
  //         setUser(prev => ({
  //           ...prev,
  //           ...updatedData
  //         }));
          
  //         // Also update targetLevel in localStorage to ensure diagnostic exams use the right level
  //         if (updatedData.target_level) {
  //           localStorage.setItem('selectedLevel', updatedData.target_level);
  //         }
          
  //         console.log('Profile updated successfully');
  //       } else {
  //         let errorMessage = `Status: ${response.status} ${response.statusText}`;
  //         try {
  //           const errorData = await response.json();
  //           console.error('Failed to update profile:', errorData);
  //           errorMessage += ` - ${errorData.message || 'Unknown error'}`;
  //         } catch (parseError) {
  //           console.error('Error parsing error response:', parseError);
  //         }
          
  //         alert(`Failed to update profile. ${errorMessage}`);
  //       }
  //     } catch (fetchError) {
  //       console.error('Network error updating profile:', fetchError);
  //       alert('Error updating profile. Please check your connection and try again.');
  //     }
  //   } catch (error) {
  //     console.error('Error in profile update process:', error);
  //     alert('Error updating profile. Please check your connection and try again.');
  //   }
  // };

  const handleLogout = () => {
    localStorage.removeItem('jwt');
    window.location.href = '/login';
  };

  const handleUnsubscribeConfirm = async () => {
    setShowUnsubscribeModal(false);
    
    // Send unsubscribe request via backend
    try {
      const jwt = localStorage.getItem('jwt');
      const response = await fetch(`${API_URL}/api/v2/payment/cancel-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${jwt}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Unsubscribe request sent successfully:', data);
      } else {
        const errorData = await response.json();
        console.error('❌ Failed to send unsubscribe request:', errorData);
      }
    } catch (error) {
      console.error('❌ Error sending unsubscribe request:', error);
    }
    
    setShowUnsubscribeConfirmation(true);
  };

  // const confirmDeleteAccount = () => {
  //   if (window.confirm("Are you sure you want to delete your account? This action cannot be undone.")) {
  //     // Handle account deletion - in a real implementation, this would call an API
  //     alert("Account deletion would be processed in a real implementation");
  //   }
  // };


  // Stats variables removed

  // Level change functions
  const handleLevelChangeClick = async () => {
    setSelectedLevel(jlptData.targetLevel);
    
    // Fetch reset preview
    const jwt = localStorage.getItem('jwt');
    try {
      const response = await fetch(`${API_URL}/api/v1/panel/user/level-reset-preview`, {
        headers: { 'Authorization': `Bearer ${jwt}` }
      });
      const preview = await response.json();
      setResetPreview(preview);
    } catch (error) {
      console.error('Error fetching reset preview:', error);
      setResetPreview(null);
    }
    
    setShowLevelChangeModal(true);
  };

  const handleLevelChange = async () => {
    if (!selectedLevel || selectedLevel === jlptData.targetLevel) {
      setShowLevelChangeModal(false);
      return;
    }

    setIsChangingLevel(true);
    const jwt = localStorage.getItem('jwt');
    
    try {
      const response = await fetch(`${API_URL}/api/v1/panel/user/change-level`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ new_level: selectedLevel })
      });

      const result = await response.json();

      if (response.ok) {
        // Update local state
        setJlptData(prev => ({ ...prev, targetLevel: selectedLevel }));
        setProfileData(prev => ({ ...prev, target_level: selectedLevel }));
        
        alert(`Level successfully changed to ${selectedLevel}!\n\nReset stats:\n` +
          `- Exams deleted: ${result.reset_stats?.exams_deleted || 0}\n` +
          `- Responses deleted: ${result.reset_stats?.responses_deleted || 0}\n` +
          `- Stages deleted: ${result.reset_stats?.stages_deleted || 0}`);
        
        // Optionally reload the page to refresh all data
        window.location.reload();
      } else {
        alert(`Error: ${result.error}`);
      }
    } catch (error) {
      console.error('Error changing level:', error);
      alert('Error changing level. Please try again.');
    } finally {
      setIsChangingLevel(false);
      setShowLevelChangeModal(false);
    }
  };

  return (
    <div className="settings">
      <div className="settings-header">
        <div>
          <h1>Settings</h1>
        </div>
      </div>

      <div className="settings-section">
        <h2>Account</h2>
        <div className="settings-card">
          <div className="account-info">
            <div className="profile-icon">
              {profileData.firstName ? profileData.firstName.charAt(0).toUpperCase() : '?'}
            </div>
            <div className="account-details">
              <h3>{`${profileData.firstName} ${profileData.lastName}`.trim() || 'User'}</h3>
              <p>{profileData.email || 'email@example.com'}</p>
            </div>
          </div>
        </div>

        <div className="subscription-card">
          <div className="subscription-header">
            <h3>Subscription</h3>
            <span className={`subscription-badge ${user?.status === 'active' ? 'premium' : 'free'}`}>
              {user?.status === 'active' ? 'Premium' : 'Free'}
            </span>
          </div>
          <p>
            {user?.status === 'active' 
              ? 'You have full access to all premium features.' 
              : 'Upgrade to premium for full access to all features.'}
          </p>
          {user?.status === 'active' ? (
            <button 
              className="unsubscribe-btn"
              onClick={() => setShowUnsubscribeModal(true)}
              style={{
                backgroundColor: 'transparent',
                color: '#9334E9',
                border: '1px solid #9334E9',
                borderRadius: '16px',
                padding: '8px 20px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                fontFamily: 'Manrope, sans-serif',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = 'rgba(147, 52, 233, 0.1)';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Unsubscribe
            </button>
          ) : (
            <button 
              className="upgrade-btn"
              onClick={() => setShowPremiumModal(true)}
            >
              Upgrade Now
            </button>
          )}
        </div>
      </div>

      {/* Statistics section removed */}

      <div className="settings-section">
        <h2>JLPT Settings</h2>
        <div className="jlpt-settings">
          <div className="settings-option">
            <div className="option-info">
              <div className="option-icon">
                <Target size={20} />
              </div>
              <div className="option-text">
                <h3>Target Level: {jlptData.targetLevel}</h3>
                <p>Change your JLPT level and reset all progress</p>
              </div>
            </div>
            <button 
              className="delete-account-btn"
              onClick={handleLevelChangeClick}
              style={{
                fontFamily: 'Manrope, sans-serif'
              }}
            >
              Change Level
            </button>
          </div>
        </div>
      </div>



      <div className="settings-section">
        <h2>Account Actions</h2>
        <div className="settings-option">
          <div className="option-info">
            <div className="option-icon danger">
              <LogOut size={20} />
            </div>
            <div className="option-text">
              <h3>Log Out</h3>
              <p></p>
            </div>
          </div>
          <button 
            className="delete-account-btn" 
            onClick={handleLogout}
          >
            Log Out
          </button>
        </div>
      </div>
      
      <div className="app-info">
        <div className="app-logo">
          <img 
            src={Mina} 
            alt="Mina" 
            className="logo" 
            onClick={() => {
              // Increment the click counter
              const newCount = clickCount + 1;
              setClickCount(newCount);
              
              // After 5 clicks, redirect to admin portal
              if (newCount >= 5) {
                window.location.href = '/account-info';
              }
            }}
            style={{ cursor: 'pointer' }}
          />
          <span style={{ fontFamily: 'Manrope, sans-serif' }}>Mina</span>
        </div>
        <div className="app-version" 
             onClick={() => window.location.href = '/user-profile'}
             style={{ cursor: 'default' }}>
          Version 1.2
        </div>
      </div>
      
      {/* Level Change Modal */}
      {showLevelChangeModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }} onClick={() => setShowLevelChangeModal(false)}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '32px',
            maxWidth: '500px',
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            fontFamily: 'Manrope, sans-serif',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }} onClick={e => e.stopPropagation()}>
            <h2 style={{ 
              marginBottom: '16px', 
              color: '#111827',
              fontSize: '20px',
              fontWeight: '600',
              fontFamily: 'Manrope, sans-serif',
              lineHeight: '1.3'
            }}>Change JLPT Level</h2>
            <p style={{ 
              marginBottom: '20px', 
              color: '#6B7280', 
              lineHeight: '1.5',
              fontSize: '15px',
              fontFamily: 'Manrope, sans-serif'
            }}>
              <strong>Warning:</strong> Changing your level will completely reset all your progress, including:
            </p>
            
            {resetPreview && (
              <div style={{ 
                backgroundColor: '#FEF3C7', 
                padding: '16px', 
                borderRadius: '8px', 
                marginBottom: '20px',
                border: '1px solidrgb(118, 36, 251)'
              }}>
                <h4 style={{ 
                  margin: '0 0 12px 0', 
                  color: '#92400E',
                  fontSize: '14px',
                  fontWeight: '600',
                  fontFamily: 'Manrope, sans-serif'
                }}>Data that will be deleted:</h4>
                <ul style={{ 
                  margin: 0, 
                  paddingLeft: '20px', 
                  color: '#92400E',
                  fontSize: '14px',
                  fontFamily: 'Manrope, sans-serif'
                }}>
                  <li>Personalized Exams: {resetPreview.data_to_reset?.personalized_exams || 0}</li>
                  <li>Diagnostic Exams: {resetPreview.data_to_reset?.diagnostic_exams || 0}</li>
                  <li>Mock Exams: {resetPreview.data_to_reset?.mock_exams || 0}</li>
                  <li>Completed Stages: {resetPreview.data_to_reset?.stages_completed || 0}</li>
                  <li>Saved Questions: {resetPreview.data_to_reset?.saved_questions || 0}</li>
                </ul>
              </div>
            )}
            
            <div style={{ marginBottom: '24px' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '600',
                fontSize: '14px',
                color: '#374151',
                fontFamily: 'Manrope, sans-serif'
              }}>
                New Target Level:
              </label>
              <div style={{ position: 'relative' }}>
                <select 
                  value={selectedLevel}
                  onChange={(e) => setSelectedLevel(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px 40px 12px 12px',
                    borderRadius: '8px',
                    border: '1px solid #D1D5DB',
                    fontSize: '15px',
                    fontFamily: 'Manrope, sans-serif',
                    color: '#374151',
                    backgroundColor: 'white',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    cursor: 'pointer'
                  }}
                >
                  <option value="N5">N5 - Beginner</option>
                  <option value="N4">N4 - Elementary</option>
                  <option value="N3">N3 - Intermediate</option>
                  <option value="N2">N2 - Upper Intermediate</option>
                  <option value="N1">N1 - Advanced</option>
                </select>
                <div style={{
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#9CA3AF'
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>
            
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
              <button
                onClick={() => setShowLevelChangeModal(false)}
                style={{
                  padding: '14px 32px',
                  borderRadius: '12px',
                  border: '1px solid #E5E7EB',
                  backgroundColor: 'white',
                  color: '#374151',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  fontFamily: 'Manrope, sans-serif',
                  minWidth: '120px',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#F9FAFB';
                  e.target.style.borderColor = '#D1D5DB';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = '#E5E7EB';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleLevelChange}
                disabled={isChangingLevel || selectedLevel === jlptData.targetLevel}
                style={{
                  padding: '14px 32px',
                  borderRadius: '12px',
                  border: 'none',
                  backgroundColor: isChangingLevel ? '#9CA3AF' : '#DC2626',
                  color: 'white',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: isChangingLevel ? 'not-allowed' : 'pointer',
                  fontFamily: 'Manrope, sans-serif',
                  minWidth: '120px',
                  transition: 'all 0.2s ease',
                  boxShadow: isChangingLevel ? '0 1px 3px rgba(0, 0, 0, 0.1)' : '0 2px 4px rgba(220, 38, 38, 0.2)'
                }}
                onMouseOver={(e) => {
                  if (!isChangingLevel && selectedLevel !== jlptData.targetLevel) {
                    e.target.style.backgroundColor = '#B91C1C';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 8px rgba(220, 38, 38, 0.3)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!isChangingLevel && selectedLevel !== jlptData.targetLevel) {
                    e.target.style.backgroundColor = '#DC2626';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 4px rgba(220, 38, 38, 0.2)';
                  }
                }}
              >
                {isChangingLevel ? 'Changing...' : 'Confirm Reset & Change Level'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      <PricingModal 
        isOpen={showPremiumModal}
        onClose={() => setShowPremiumModal(false)}
        source="Settings Page"
      />

      {/* Unsubscribe Confirmation Modal */}
      {showUnsubscribeModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }} onClick={() => setShowUnsubscribeModal(false)}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '32px',
            maxWidth: '400px',
            width: '100%',
            textAlign: 'center',
            fontFamily: 'Manrope, sans-serif',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }} onClick={e => e.stopPropagation()}>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '16px',
              lineHeight: '1.3'
            }}>
              Are you sure you want to unsubscribe?
            </h2>
            
            <p style={{
              fontSize: '15px',
              color: '#6B7280',
              lineHeight: '1.5',
              marginBottom: '32px'
            }}>
              You will lose access to all premium features including unlimited trainings, full analytics, and personalized study plans.
            </p>

            <div style={{
              display: 'flex',
              gap: '16px',
              justifyContent: 'center'
            }}>
              <button
                onClick={() => setShowUnsubscribeModal(false)}
                style={{
                  padding: '14px 32px',
                  borderRadius: '12px',
                  border: '1px solid #E5E7EB',
                  backgroundColor: 'white',
                  color: '#374151',
                  fontWeight: '600',
                  fontSize: '15px',
                  cursor: 'pointer',
                  fontFamily: 'Manrope, sans-serif',
                  minWidth: '100px',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#F9FAFB';
                  e.target.style.borderColor = '#D1D5DB';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.borderColor = '#E5E7EB';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
                }}
              >
                No
              </button>
              
              <button
                onClick={handleUnsubscribeConfirm}
                style={{
                  padding: '14px 32px',
                  borderRadius: '12px',
                  border: 'none',
                  backgroundColor: '#9333EA',
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '15px',
                  cursor: 'pointer',
                  fontFamily: 'Manrope, sans-serif',
                  minWidth: '100px',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 4px rgba(147, 51, 234, 0.2)'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#7C3AED';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 8px rgba(147, 51, 234, 0.3)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#9333EA';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 2px 4px rgba(147, 51, 234, 0.2)';
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Unsubscribe Success Modal */}
      {showUnsubscribeConfirmation && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
          padding: '20px'
        }} onClick={() => setShowUnsubscribeConfirmation(false)}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '32px',
            maxWidth: '400px',
            width: '100%',
            textAlign: 'center',
            fontFamily: 'Manrope, sans-serif',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
          }} onClick={e => e.stopPropagation()}>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#111827',
              marginBottom: '16px',
              lineHeight: '1.3'
            }}>
              Unsubscription Request Received
            </h2>
            
            <p style={{
              fontSize: '15px',
              color: '#6B7280',
              lineHeight: '1.5',
              marginBottom: '32px'
            }}>
              We've received your unsubscription request and will process your cancellation from our premium plan. You'll continue to have access to premium features until the end of your current billing period.
            </p>

            <button
              onClick={() => setShowUnsubscribeConfirmation(false)}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                border: 'none',
                backgroundColor: '#9333EA',
                color: 'white',
                fontWeight: '600',
                fontSize: '14px',
                cursor: 'pointer',
                fontFamily: 'Manrope, sans-serif'
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsView;